var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wid-100p hei-100p"},[_vm._v(" noti popup ")])
}
var staticRenderFns = []

export { render, staticRenderFns }